<template>
	<main>
		<h1>Command API explorer</h1>

		<form>
			<BaseFormComponent id="command_api_token" label="Enter your application token">
				<BaseInput
					v-model="apiToken"
					id="command_api_token"
					required
					autocomplete="off"
				/>
			</BaseFormComponent>
		</form>

		<template v-if="apiToken">
			<AddCommandForm
				:api-token="apiToken"
				authenticate-api-token
				:copy-command="commandToReplay"
				@commandAdded="onCommandAdded"
			/>
			<CommandsList
				:commands="commands"
				@requestDelete="deleteCommand"
				@requestReplay="replayCommand"
			/>
		</template>
	</main>
</template>

<script>
import { getErrors } from '@/core/http'
import AddCommandForm from '../components/AddCommandForm'
import CommandsList from '../components/CommandsList'
import commandsHttp from '../commandsHttp'
import BaseFormComponent from '@/core/components/BaseFormComponent'
import BaseInput from '@/core/components/BaseInput'
import deleteMixin from '@/modules/command/deleteMixin'
import replayMixin from '@/modules/command/replayMixin'

const API_TOKEN_LOCALSTORAGE_KEY = 'jeopardy_explorer';

export default {
	name: 'Explorer',
	mixins: [
		deleteMixin,
		replayMixin,
	],
	components: {
		BaseInput,
		BaseFormComponent,
		AddCommandForm,
		CommandsList,
	},
	data() {
		return {
			apiToken: '',
			commands: [],
		};
	},
	watch: {
		apiToken(newValue) {
			if (newValue === '') {
				this.commands = [];
				localStorage.removeItem(API_TOKEN_LOCALSTORAGE_KEY);

				return;
			}

			localStorage.setItem(API_TOKEN_LOCALSTORAGE_KEY, newValue);

			this.fetchCommands();
		},
	},
	created() {
		let storedApiToken = localStorage.getItem(API_TOKEN_LOCALSTORAGE_KEY);
		if (storedApiToken) {
			this.apiToken = storedApiToken;
		}

		this.fetchCommands()
			.catch(response => {
				const errors = getErrors(response);

				errors.forEach((text) => {
					this.$flashMessage.show({
						type: 'error',
						text,
					});
				});
			})
		;
	},
	methods: {
		async fetchCommands() {
			if (!this.apiToken) {
				return;
			}

			/** @var {Array|Object} commands */
			const commands = await commandsHttp.getAll({
				api_token: this.apiToken,
			}, {
				'Authorization': `token ${this.apiToken}`,
			});

			this.commands = commands.reverse();
		},
		onCommandAdded(newCommand) {
			this.commands.unshift(newCommand);
		},
	},
};
</script>

<style scoped>
main {
	display: grid;
	grid-template-columns: 1fr 1fr;
}
</style>
